module.exports = __webpack_public_path__ + "media/images/country_flags/it-414b93f2e48f37a40b48612266c465e2.png";